import Validation from "@irati/utils/validation"
import {InjectedIntl} from "react-intl"

export const customRewardNameSchema = (intl: InjectedIntl, maxChars: number) => {
  return Validation.string("platform.defaultValidation.required")
    .test("notJustSpaces", "platform.defaultValidation.notJustSpaces", (value: string) => value && value.trim().length !== 0)
    .max(maxChars, intl.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: intl.formatNumber(maxChars)}))
}
